var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"poster":_vm.item.videoImg,"controls":""}},[_c('source',{attrs:{"src":_vm.item.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }